import { URLS } from '../../../constants';
import apiClient from '../../client';

const editClaimSecondaryQualifierAPI = {
  editClaimAddSecondaryQualifier: ({
    id,
    idCode,
    secondaryQualifierId,
    userId,
  }: {
    id: any;
    idCode: any;
    secondaryQualifierId: any;
    userId: any;
  }) =>
    apiClient.post(URLS.editClaimAddSecondaryQualifier, {
      data: {
        id,
        idCode,
        secondaryQualifierId,
        userId,
      },
    }),
  getAllSecondaryQualifierDataCategoryByType: ({ type }: { type: any }) =>
    apiClient.post(URLS.getAllSecondaryQualifierDataCategoryByType, {
      data: {
        type,
      },
    }),
  editSecondaryQualifier: ({
    id,
    idCode,
    secondaryQualifierId,
  }: {
    id: any;
    idCode: any;
    secondaryQualifierId: any;
  }) =>
    apiClient.post(URLS.editSecondaryQualifier, {
      data: {
        id,
        idCode,
        secondaryQualifierId,
      },
    }),
  deleteSecondaryQualifier: ({ id }: { id: any }) =>
    apiClient.post(URLS.deleteSecondaryQualifier, {
      data: {
        id,
      },
    }),
  getSecondaryQualifierByClaimId: ({ id, type }: { id: any; type: any }) =>
    apiClient.post(URLS.getSecondaryQualifierByClaimId, {
      data: { id, type },
    }),
};
export default editClaimSecondaryQualifierAPI;
